import React from "react";
import { Box } from "@mui/material";
import logo from "../assets/login.png";

const LoginLogo = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <img
      src={logo}
      alt="JifJaff Logo"
      style={{
        width: "auto",
        height: "auto",
        objectFit: "contain",
        display: "block",
      }}
    />
  </Box>
);

export default LoginLogo;
